import Service from "../../AuthService";
const factoryEmployeeExport = {
    getFactoryEmployeeExport(page,data){
        return Service.get(`/factory_employee_export?page=${page}` +
            `&factory_id=${data.factory_id}` +
            `&date=${data.date}` +
            `&employee_id=${data.employee_id}`
        );
    },
    showFactoryEmployeeExport(id){
        return Service.get('/factory_employee_export/'+id);
    },
    createFactoryEmployeeExport(data){
        return Service.post('/factory_employee_export',data);
    },
    updateFactoryEmployeeExport(id,data){
        return Service.put('/factory_employee_export/'+id,data);
    },
    deleteFactoryEmployeeExport(id){
        return Service.delete('/factory_employee_export/'+id);
    },
}
export default factoryEmployeeExport
